import React, { FC } from 'react';
import { DrivingMonthlyData } from './DrivingMonthlyData/DrivingMonthlyData';

export const DrivingMonthlyDataPage: FC = () => {
  return <DrivingMonthlyData />;
};
